
import lazyload from "@/directives/lazyload";
import Anie from "@/assets/images/landing/img/anie.webp";
import EricJ from "@/assets/images/landing/img/EricJ.png";
import Tina from "@/assets/images/landing/img/ttina.png";


import LogoAmerican from "@/assets/images/landing/svg/flag-american.svg";
export default {
  data() {
    return {
      stories: [
        {
          name: "Jenny S.",
          text:
          `I don't expect everyone I meet to tell me their life story. It would be really weird if they did. But there are some things, that I would like to know up front. I've been burned in the past so I am pretty careful about who I get involved with these days. So, when I met her I did what I always do now after the second date if I'm still interested in someone; I ran a Listing Locator search. I just like to be sure that they are who they say they are. She had given me her real name and address, but she hadn't told me she was married. When I asked her about she was kind of shocked. She told me that technically they were separated but was annoyed at the "intrusion." I explained that it wasn't personal and that verifying someone's identity is a good thing to do, especially for a woman just getting back into the dating scene. I even gave her the link, and that's when she admitted that I had a point. The chemistry didn't click, but we are still friends. I did my good deed LOL!`,
          imgMain: Tina,
          imgSecond: Anie,
          imgThird: EricJ,
          logo: LogoAmerican,
        },
        {
          name: "Annie P.",
          text:
            `One random day, he told me he was going on a trip with his guy friends. He said that the connection there is poor so he will not be able to talk much. There was something fishy in all the trip videos he sent to me. My suspicion grew from there. I felt like he was hiding something and he was not with his guys. Then I remembered a friend's similar story and how she found out the truth through iFindCheaters. So, I ran a listing locator search and it confirmed my suspicion. He was not where he claimed to be and by asking some clever questions, I found out that he planned that trip with a girl he was cheating with. I may have trust issues now, but at least I know not to ignore my gut feelings.`,
          imgMain: Anie,
          imgSecond: EricJ,
          imgThird: Tina,
          logo: LogoAmerican,
        },
        {
          name: "Matt W.",
          text:
            `After a couple months of exciting start to our relationship, I started noticing subtle changes in his mannerisms around me. He started dodging my calls, there was a lack of interest in planning dates from his side. Initially, I believed his reasons for being busy with work or "personal stuff" to be genuine, but it soon turned into a suspicion when one day he asked me to dinner and I excitedly agreed. Minutes later, he cancelled on me saying something urgent came up. It was very weird so I couldn't keep myself from solving this riddle. I found myself doing a listing locator search on iFindCheaters only to discover that he was having dinner the same evening he cancelled with me, but with another dude! It was an insulting revelation, but I'm glad I found out sooner than later.`,
          imgMain: EricJ,
          imgSecond: Tina,
          imgThird: Anie,
          logo: LogoAmerican,
        },
      ],
      transitionClass: "list-next",
      pageNumber: 0,
    };
  },
  methods: {
    prevPage() {
      this.pageNumber--;
      this.transitionClass = "list-prev";
    },
    nextPage() {
      this.pageNumber++;
      this.transitionClass = "list-next";
    },
  },
  directives: {
    lazyload,
  },
};
